<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">Audit Log</h1>
    <p class="text-gray-600 mt-2">Histórico de ações administrativas</p>
  </div>

  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Entity Type</label>
        <input [(ngModel)]="entityType" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Fornecedor, Cupom, ...">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Ação</label>
        <input [(ngModel)]="action" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="upgrade_vitrine, ...">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">User ID</label>
        <input [(ngModel)]="userId" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="UUID do usuário">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Data Início</label>
        <input [(ngModel)]="startDate" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Data Fim</label>
        <input [(ngModel)]="endDate" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md">
      </div>
    </div>
    <div class="flex gap-2 mt-4">
      <button (click)="load()" class="px-4 py-2 bg-blue-600 text-white rounded-md">🔍 Filtrar</button>
      <button (click)="resetFilters()" class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">✕ Limpar</button>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entity</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Timestamp</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Changes</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let a of items" class="hover:bg-gray-50">
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">{{ a.entityType }}</div>
              <div class="text-xs text-gray-500">ID: {{ a.entityId }}</div>
            </td>
            <td class="px-6 py-4">{{ a.action }}</td>
            <td class="px-6 py-4">
              <div class="text-sm text-gray-900">{{ a.userEmail }}</div>
              <div class="text-xs text-gray-500">UserId: {{ a.userId }}</div>
            </td>
            <td class="px-6 py-4">{{ a.timestamp | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="px-6 py-4">
              <button (click)="viewChanges(a)" class="text-blue-600 hover:text-blue-900">Ver</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              Mostrando
              <span class="font-medium">{{ (page - 1) * pageSize + 1 }}</span>
              até
              <span class="font-medium">{{ displayEnd() }}</span>
              de
              <span class="font-medium">{{ total }}</span>
              resultados
            </p>
          </div>
          <div>
            <app-pagination [page]="page" [pageSize]="pageSize" [total]="total" (pageChange)="onPageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showModal" class="fixed inset-0 bg-black/50 flex items-center justify-center">
    <div class="bg-white rounded-lg shadow p-6 w-full max-w-2xl">
      <h2 class="text-xl font-semibold mb-4">Changes (JSON)</h2>
      <pre class="bg-gray-50 p-3 rounded text-xs overflow-auto max-h-96">{{ modalChanges }}</pre>
      <div class="mt-4 text-right">
        <button (click)="closeModal()" class="px-4 py-2 border rounded">Fechar</button>
      </div>
    </div>
  </div>
</div>
